import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  wizardBlockCardClassName,
  wizardBlockShellClassName,
} from '../wizardBlockChrome';
import { Button } from '@/components/ui/button';
import { TiptapEditor } from '@/components/common/TiptapEditor';
import { HelpLabel } from '@/features/guided-help';
import { PRIZE_TEMPLATE } from '../../sports/shared/templates/basicInfoTemplates';
import { useTemplateApplyConfirm } from './useTemplateApplyConfirm';
import { TemplateReplaceDialog } from './TemplateReplaceDialog';

export interface BasicInfoPrizesFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  wrapInCard?: boolean;
}

export function BasicInfoPrizesField({
  value,
  onChange,
  required = false,
  wrapInCard = true,
}: BasicInfoPrizesFieldProps) {
  const {
    isConfirmOpen,
    requestApply,
    dismiss,
    confirmReplace,
  } = useTemplateApplyConfirm();

  const applyTemplate = (content: string) => onChange(content);

  const editorBlock = (
    <div className="space-y-2" data-guide-id="wizard.basicInfo.prizes">
      <HelpLabel topicId="wizard.basicInfo.prizes">
        Descripción de premios {required && '*'}
      </HelpLabel>
      <TiptapEditor
        ariaLabel="Premios"
        content={value}
        onChange={onChange}
        placeholder="Describe los premios del torneo..."
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          requestApply(PRIZE_TEMPLATE, value, applyTemplate)
        }
      >
        Aplicar plantilla
      </Button>
      <p className="text-xs text-gray-500">
        Detalla los premios para los ganadores y finalistas.
      </p>
    </div>
  );

  const dialog = (
    <TemplateReplaceDialog
      open={isConfirmOpen}
      onOpenChange={(open) => !open && dismiss()}
      onConfirm={confirmReplace}
    />
  );

  if (!wrapInCard) {
    return (
      <>
        <div className={wizardBlockShellClassName}>{editorBlock}</div>
        {dialog}
      </>
    );
  }

  return (
    <Card className={wizardBlockCardClassName}>
      <CardHeader>
        <CardTitle className="text-lg">Premios</CardTitle>
      </CardHeader>
      <CardContent>
        {editorBlock}
        {dialog}
      </CardContent>
    </Card>
  );
}
